import { Fragment, FC } from 'react';
import { useThingsToDo } from '@/libs/fleet-api/services/things-todo';
import CountUp from 'react-countup';
import { Card, Flex, List } from 'antd';
import { PageName, useApp } from '@/App';

const FBDHThingsToDo: FC = () => {
	const { navigate } = useApp();
	const { data: todoData, isLoading } = useThingsToDo();
	const counts = todoData?.data;

	const data = [
		{
			title: 'Customer Checking',
			count: counts?.businessApproval ?? 0,
			link: 'FBDHCustomerCheckingListPage',
		},
		{
			title: 'Survey Approval',
			count: counts?.requestSurvey ?? 0,
			link: 'FBDHRequestSurveyListPage',
		},
		{
			title: 'View Laporan Kunjungan',
			count: counts?.visitReport ?? 0,
			link: 'FBDHVisitReportListPage',
		},
		{
			title: 'Reject Laporan Kunjungan',
			count: counts?.visitRejection ?? 0,
			link: 'FBDHVisitReportRejectListPage',
		},
		{
			title: 'Pipeline Hot Prospect',
			count: counts?.pipelineHotProspect ?? 0,
			link: 'FBDHPipelineListPage',
		},
		{
			title: 'Pipeline Golive',
			count: counts?.pipelineGoLive ?? 0,
			link: 'GoliveListPage',
		},
		{
			title: 'Nota Analisa Pembiayaan',
			count: counts?.nap ?? 0,
			link: 'NAPListPage',
		},
		{
			title: 'Pemberitahuan Fasilitas',
			count: counts?.spf ?? 0,
			link: 'SPFListPage',
		},
		{
			title: 'Purchase Order',
			count: counts?.purchaseOrder ?? 0,
			link: 'FBDHPOListPage',
		},
		{
			title: 'Memo Pencairan Pembiayaan',
			count: counts?.mpp ?? 0,
			link: 'MPPListPage',
		},
	];

	return (
		<Fragment>
			<List
				loading={isLoading}
				grid={{ gutter: 20, column: 2 }}
				dataSource={data}
				renderItem={(item) => {
					return (
						<List.Item style={{ marginBottom: 20 }}>
							<Card
								hoverable
								size="small"
								style={{ borderRadius: 0 }}
								onClick={() => {
									navigate(item.link as PageName);
								}}
							>
								<Flex
									justify="space-between"
									align="center"
								>
									{item.title}
									<div
										className={`badge-todo ${item.count > 0 ? 'badge-active' : ''}`}
									>
										<CountUp end={item.count} />
									</div>
								</Flex>
							</Card>
						</List.Item>
					);
				}}
			/>
		</Fragment>
	);
};

export default FBDHThingsToDo;
